/**
 * status that means we could not get the desired data. That could mean that we couldnt find a certain candle, etc
 * {
	"messageType": "alertNotification",
	"notificationId": 1645455068661,
	"notificationDetails": {"errorType":"SYSTEM_ERROR","notificationType":"ERROR","TRADE_PLAN":{"type":"BASIC_TRADING_SYSTEM","id":1,"symbol":"XYZ"}},
	"status": "MISSING_DATA",
	"statusDetails": {"missingData":null},
	"date": "2022-02-21T09:51:09.402-0500",
	"timestamp": "1645455069405"
}

 * @param {*} statusDetails 
 * @returns returns object with field:
 * 1) missingData
 */
export function missingDataParser(statusDetails) {
  const parsedObj = {
    missingData: null,
  };
  if (statusDetails) {
    parsedObj.missingData = statusDetails.missingData ?? null;
  }

  return parsedObj;
}
